import React from 'react';
import {useNotifier} from "../redux/hooks/useNotifier";
export const Notifications = () => {
    useNotifier();
    return (
        <></>
    );
};

